import { createStandardAction } from "typesafe-actions";

export const savePackingList = createStandardAction("@@utils/SAVE_PACKING_LIST")();